module.exports = __webpack_public_path__ + "6ddd923cdad37967dcb1bb9cc42a16af.svg";